"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _ListResultsStatus = require('web/components/ListResultsStatus'); var _ListResultsStatus2 = _interopRequireDefault(_ListResultsStatus);
var _Form = require('web/components/Form');
var _Org = require('web/components/Settings/Org');
var _Headings = require('web/components/Settings/Headings');
var _DataTable = require('web/components/DataTable');
var _EmptyState = require('web/components/Settings/EmptyState'); var _EmptyState2 = _interopRequireDefault(_EmptyState);
var _Skeleton = require('web/components/Settings/Skeleton'); var _Skeleton2 = _interopRequireDefault(_Skeleton);
var _apiKeyColumns = require('./components/apiKeyColumns');
var _RevokeAPIKeyModal = require('./components/RevokeAPIKeyModal'); var _RevokeAPIKeyModal2 = _interopRequireDefault(_RevokeAPIKeyModal);
var _APIKeyExpiryModal = require('./components/APIKeyExpiryModal'); var _APIKeyExpiryModal2 = _interopRequireDefault(_APIKeyExpiryModal);
var _CreateAPIKeyModal = require('./components/CreateAPIKeyModal'); var _CreateAPIKeyModal2 = _interopRequireDefault(_CreateAPIKeyModal);
var _RequestAPIAccess = require('./components/RequestAPIAccess'); var _RequestAPIAccess2 = _interopRequireDefault(_RequestAPIAccess);
var _helpers = require('./helpers');
















// Why keys can't be created yet (no API access until the BAA is signed).
const BAA_NOTE = 'BloomText turns on API access once your BAA is signed. Then you can create keys here.'



const keyID = (k) => k.ID
const keyName = (k) => k.Name

// A dialog belongs to the org it was opened in.






// Account → API keys & integrations (screens 10, 11).
const APIKeysTab = ({
  orgKey, orgs, keys, apiAccess, hasLoadFailed, onKeyChanged, onKeyCreated,
}) => {
  const orgName = _react.useMemo.call(void 0, 
    () => {
      const names = new Map(orgs.map(o => [o.OrgKey , o.Name]))
      return (k) => _nullishCoalesce(names.get(k), () => ( 'An organization'))
    },
    [orgs],
  )
  const [opened, setOpened] = _react.useState(null)
  // creating is the org the create dialog was opened in; each opening
  // starts a fresh dialog (createCount), so a secret never shows twice.
  const [creating, setCreating] = _react.useState(null)
  const [createCount, setCreateCount] = _react.useState.call(void 0, 0)
  // Moving to another org's page drops the dialog, so it never confirms one
  // org's key against another org, and coming back doesn't reopen it.
  if (opened && opened.orgKey !== orgKey) setOpened(null)
  if (creating && creating !== orgKey) setCreating(null)
  const selection = _optionalChain([opened, 'optionalAccess', _ => _.orgKey]) === orgKey ? opened : null
  const selectedKey = _nullishCoalesce(_optionalChain([selection, 'optionalAccess', _2 => _2.key]), () => ( null))
  const dialog = _nullishCoalesce(_optionalChain([selection, 'optionalAccess', _3 => _3.dialog]), () => ( null))

  const onRevoke = _react.useCallback.call(void 0, 
    (key) => setOpened({ orgKey, key, dialog: 'revoke' }),
    [orgKey],
  )
  const onChangeExpiry = _react.useCallback.call(void 0, 
    (key) => setOpened({ orgKey, key, dialog: 'expiry' }),
    [orgKey],
  )
  // Closing is scoped to the selection that opened the dialog: a command
  // that finishes after the admin moved on (another org, or another key)
  // closes nothing they've opened since.
  const onCloseDialog = _react.useCallback.call(void 0, 
    () => setOpened(o => o && o === selection ? { ...o, dialog: null } : o),
    [selection],
  )

  const onConfirmRevoke = _react.useCallback.call(void 0, 
    async () => {
      if (!selection) return
      const r = await _actions2.default.revokeAPIKey({ OrgKey: selection.orgKey, APIKeyKey: selection.key.ID })
      onKeyChanged(selection.orgKey, r.Key)
    },
    [selection, onKeyChanged],
  )
  const onConfirmExpiry = _react.useCallback.call(void 0, 
    async (Expires) => {
      if (!selection) return
      const r = await _actions2.default.setAPIKeyExpiry({ OrgKey: selection.orgKey, APIKeyKey: selection.key.ID, Expires })
      onKeyChanged(selection.orgKey, r.Key)
    },
    [selection, onKeyChanged],
  )

  const onOpenCreate = _react.useCallback.call(void 0, 
    () => {
      setCreateCount(n => n + 1)
      setCreating(orgKey)
    },
    [orgKey],
  )
  const onCloseCreate = _react.useCallback.call(void 0, () => setCreating(null), [])
  const onConfirmCreate = _react.useCallback(
    async k => {
      if (!creating) throw new Error('no create dialog')
      // Sent past the Redux actions, so the secret never lands in an
      // action payload or the action log.
      const r = await _client2.default.send('CreateAPIKey', { OrgKey: creating, ...k })
      onKeyCreated(creating)
      return r
    },
    [creating, onKeyCreated],
  )

  const columns = _react.useMemo.call(void 0, 
    // orgKey is the account's default org.
    () => _apiKeyColumns.apiKeyColumns.call(void 0, { orgName, defaultOrgKey: orgKey, onChangeExpiry, onRevoke }),
    [orgName, orgKey, onChangeExpiry, onRevoke],
  )

  const hasKeys = !!keys && keys.length > 0
  const isEmpty = !!keys && keys.length === 0

  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "api-keys", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}
      , _react2.default.createElement('div', { className: "settings--acct--section-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
        , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, "API keys" )
        ,  apiAccess && hasKeys && _react2.default.createElement(_Form.Button, { onClick: onOpenCreate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}, "Create API key"  ) 
      )
      ,  isEmpty && (
        _react2.default.createElement(_EmptyState2.default, {
          title: "No API keys yet"   ,
          action: apiAccess ? { label: 'Create API key', onClick: onOpenCreate } : undefined,
          reason: BAA_NOTE,
          reasonActions: _react2.default.createElement(_RequestAPIAccess2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
, "A key lets your own systems, like an HR feed or a reminder service, call the BloomText API for this account's organizations."


        )
      )
      ,  hasKeys && (
        _react2.default.createElement(_react2.default.Fragment, null
          ,  apiAccess === false && (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement('p', { className: "settings--org-api-keys--note", role: "note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}
                ,  BAA_NOTE , " Existing keys won't work until then."
              )
              , _react2.default.createElement('div', { className: "settings--empty-state--actions settings--org-api-keys--access-actions" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
                , _react2.default.createElement(_RequestAPIAccess2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}} )
              )
            )
          )
          , _react2.default.createElement('div', { className: "data-table settings--org-api-keys--list" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
            , _react2.default.createElement(_DataTable.DataTableGrid, {
              label: "API keys" ,
              columns: columns,
              rows: keys,
              rowKey: keyID,
              rowLabel: keyName,
              rowClassName: k => !_helpers.canManageKey.call(void 0, k) && 'settings--org-api-keys--row--revoked', __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
            )
          )
        )
      )
      ,  !keys && !hasLoadFailed && _react2.default.createElement(_Skeleton2.default, { lines: 3, label: "Loading API keys"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}} ) 
      ,  !keys && hasLoadFailed && (
        _react2.default.createElement(_ListResultsStatus2.default, { isLoading: false, resultsCount: 0, noResultsLabel: "Failed to load API keys."    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}} )
      )
      , _react2.default.createElement(_CreateAPIKeyModal2.default, {
        key: createCount,
        orgs: orgs,
        isOpen: creating === orgKey,
        onClose: onCloseCreate,
        onProceed: onConfirmCreate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
      )
      ,  selectedKey && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_RevokeAPIKeyModal2.default, {
            key: `revoke-${selectedKey.ID}`,
            isOpen: dialog === 'revoke',
            onClose: onCloseDialog,
            apiKey: selectedKey,
            onProceed: onConfirmRevoke, __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}
          )
          , _react2.default.createElement(_APIKeyExpiryModal2.default, {
            key: `expiry-${selectedKey.ID}`,
            isOpen: dialog === 'expiry',
            onClose: onCloseDialog,
            apiKey: selectedKey,
            onProceed: onConfirmExpiry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}
          )
        )
      )
    )
  )
}

exports. default = APIKeysTab
